module.exports = __webpack_public_path__ + "news-01.jpg?65a1f36877bd6701336b695ba0601ef6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-01.jpg
// module id = 237
// module chunks = 0